var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepperDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "1px",
    viewBox: "0 0 61 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CA4B7258-F95D-4D53-86FD-478A6EF9DC5D@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-Desktop",
    stroke: "none",
    strokeWidth: 0.3,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "2,3",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SME_Asia_B2C_Desktop_Enter_Date_Picker",
    transform: "translate(-777.000000, -43.000000)",
    stroke: "#B0B7C3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TOP_NAV"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__-/-Utilities-/-Stepper-/-Neg-/-Future-step",
    transform: "translate(250.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 60.6262626,
    y1: 14.5,
    x2: 122,
    y2: 14.5,
    id: "Line-right"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperDash);
export default __webpack_public_path__ + "static/media/StepperDash.e9474b23756627cb461cd7d9627f939d.svg";
export { ForwardRef as ReactComponent };